import type { AnyObject } from "@entrilia/shared/types.ts";
import type {
  GroupTotal,
  TabularColumn,
  TabularSnapshot,
  TabularRow,
} from "../../../../../../../../api/types/svTypes.ts";

export enum GridDataStateActionType {
  UPDATE_STATE = "UPDATE_STATE",
  LOADING_STARTED = "LOADING_STARTED",
  LOADING_ENDED = "LOADING_ENDED",
  LOADING_GROUPS_STARTED = "LOADING_GROUPS_STARTED",
  LOADING_GROUPS_ENDED = "LOADING_GROUPS_ENDED",
  INITIALIZED = "INITIALIZED",
}

export type UpdateGridDataStateAction = {
  type: GridDataStateActionType.UPDATE_STATE;
  payload: Partial<GridDataState>;
};
export type LoadingStartedAction = {
  type: GridDataStateActionType.LOADING_STARTED;
};
export type LoadingEndedAction = {
  type: GridDataStateActionType.LOADING_ENDED;
};
export type InitializedAction = {
  type: GridDataStateActionType.INITIALIZED;
};

export type ReducerAction = UpdateGridDataStateAction | LoadingStartedAction | LoadingEndedAction | InitializedAction;

export type GridDataState = {
  snapshot?: TabularSnapshot;
  error?: string;
  rows: TabularRow[];
  groupTotals: GroupTotal[];
  grandTotals: AnyObject;
  totalCount: number;
  loading: boolean;
  requestCount: number;
  columns: TabularColumn[];
  initialized: boolean;
};

export const initialGridDataState: GridDataState = {
  grandTotals: {},
  groupTotals: [],
  loading: false,
  requestCount: 0,
  rows: [],
  totalCount: 0,
  columns: [],
  initialized: false,
};

export const gridDataStateReducer = (actualState: GridDataState, action: ReducerAction) => {
  switch (action.type) {
    case GridDataStateActionType.UPDATE_STATE: {
      const state: GridDataState = {
        ...actualState,
        ...action.payload,
      };
      return state;
    }
    case GridDataStateActionType.LOADING_STARTED: {
      const state: GridDataState = {
        ...actualState,
        loading: true,
      };
      return state;
    }
    case GridDataStateActionType.LOADING_ENDED: {
      const state: GridDataState = {
        ...actualState,
        loading: false,
      };
      return state;
    }
    case GridDataStateActionType.INITIALIZED: {
      const state: GridDataState = {
        ...actualState,
        initialized: true,
      };
      return state;
    }
    default:
      return actualState;
  }
};
